import PublicPage from './PublicPage';

const Legal = () => {
  return <PublicPage pageType="legal" backLink="/" />;
};

export default Legal;
